<template>
  <Transition appear name="ui-dialog-transition" :duration="300">
    <slot></slot>
  </Transition>
</template>

<script lang="ts" setup></script>

<style lang="scss">
.ui-dialog {
  $self: &;

  &-transition {
    &-enter-active #{$self}-content,
    &-leave-active #{$self}-content {
      transition: all 300ms ease;
    }

    &-enter-from #{$self}-content,
    &-leave-to #{$self}-content {
      transform: scale(0.8);
      opacity: 0;
    }
  }
}
</style>
